import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../App.css"; // Your CSS
import LiveChat from "../components/LiveChat";
import GetQuoteButton from "../components/GetQuoteButton";
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";

const offers = [
  {
    //icon: "⚙️",
    title: "Marine Machinery Overhauls",
    description: "We provide vessel owners and operators with reliable, high-quality services to maintain and extend the lifespan of their critical onboard machinery, delivered by experienced professionals at strategically located facilities.",
  },
  {
    //icon: "🛠️",
    title: "Engineering Retrofits",
    description: "We are involved in upgrading existing ship systems to boost performance, enhance efficiency and safety or meet regulatory requirements. This includes design, procurement, installation, testing and leveraging local expertise for vessels operating in the Indian Ocean region.",
  },
  {
    //icon: "❄️",
    title: "HVAC System Services & Troubleshooting",
    description: "We offer comprehensive HVAC services for maintenance, repairs, retrofits and troubleshooting. These services aim to ensure comfortable and efficient onboard climate control, which is crucial in Sri Lanka's tropical environment. Our work is carried out by experienced technicians in adherence to marine standards.",
  },
  {
    //icon: "🧰",
    title: "Fabrication Services",
    description:"We Offer Fabrication services, encompassing cutting, forming, joining, machining and finishing which are vital for creating products from diverse materials across the Marine industries. We offer services to cater to customers’ specific requirements.",
  },
  {
    //icon: "💡",
    title: "Electrical & Control Systems",
    description: "We offer a range of electrical and control system services, encompassing design, installation, maintenance, repair, upgrades and troubleshooting Our control system expertise likely includes PLC, DCS and SCADA with potential training and consultancy. We cater to Marine Industries, meeting local regulations and needs.",


  },
  {
    //icon: "🤖",
    title: "Automation Troubleshooting",
    description: "We specialize in diagnosing and resolving issues within automated marine systems, including PLCs, DCS, SCADA, sensors, actuators and communication networks. Our expertise in marine automation enables us to efficiently identify and rectify system faults, ensuring minimal downtime for businesses and vessels operating Sri Lanka. ",
  },
  {
    title:"Fleet Management",
    description:" Keeping Your Fleet Performing Efficiently",
  },
  {
    title: "Port machinery and crane maintenance",
    description: "Comprehensive maintenance, inspection, and repair services for port machinery, quay cranes, and heavy marine handling equipment.",
  },
];

const Marian = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <div className="sector-detail">
      <Navbar />

      <header className="sector-hero">
        <h1>Marine Sector & Afloat Ship Repairs</h1>
        <p>
          Pioneering Excellence in Afloat Ship Repairs, Marine Engineering, Operations, and Sustainability.
        </p>
      </header>

      <section className="sector-content">
        <h2>Our Marine & Afloat Engineering Services</h2>
        <p>
          CIAP Pvt Ltd offers a comprehensive range of Marine, Afloat Ship Repair, and Engineering Solutions tailored to meet the evolving demands of the maritime industry, with
          expertise including Afloat Machinery Overhauls, Ship Maintenance, Marine Refrigeration Systems, Boat Repairs, and Offshore Equipment Support across Sri Lankan and international ports.
        </p>

        <h3 className="offer-title">What We Offer:</h3>
        <ul className="offer-list">
          {offers.map((offer, index) => (
            <li 
              key={index} 
              className="offer-item"
              onMouseEnter={() => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}
            >
              <span className="offer-icon">{offer.icon}</span>
              {offer.title}
              {activeIndex === index && offer.description && (
                <div className="popup">
                  {offer.description}
                </div>
              )}
            </li>
          ))}
        </ul>
      </section>

      <LiveChat />
      <QAChatbot/>
      <GetQuoteButton/>
      <ScrollSocialIcons/>
      <BackToTopButton/>
      <Footer />
    </div>
  );
};

export default Marian;
